import React from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import { ReactComponent as Logo } from '@assets/images/logo.svg'
import CommonText from '@components/common/CommonText'
import CommonButton from '@components/common/CommonButton'

const SplashPage = () => {
  return (
    <>
      <SplashPageStyle />
      <div className="logo-title-wrapper">
        <Logo className="logo" style={{ width: '140px', height: '140px' }} />

        <CommonText
          className="title"
          color="rgba(20, 20, 20, 0.75)"
          fontWeight={300}
          fontSize={20}
          tag="span">
          당신만을 위한 작고 소중한 레시피
        </CommonText>

        <CommonButton
          link="/signup"
          className="button-sign-up"
          text="회원 가입"
          width="100%"
          height={70}
          backgroundColor="#ffa34b"
          fontSize={20}
          color="#FFFFFF"
        />
        <CommonButton
          link="/login"
          className="button-login"
          text="로그인"
          width="100%"
          height={70}
          backgroundColor="#FFFFFF"
          fontSize={20}
          color="#ffa34b"
        />
      </div>
    </>
  )
}

SplashPage.propTypes = {}

const SplashPageStyle = createGlobalStyle`
    .logo-title-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .logo {
      margin-top: 150px;
    }

    .title {
      margin-top: 35px;
    }

    .button-sign-up {
      margin-top: 230px;
    }

    .button-login {
      margin-top: 40px;
    }
`

export default SplashPage
